import React from "react";
import styles from "./MajorFooter.module.scss";
import { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK } from "@constants/common";

const MajorFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles["footer"]}>
      <p>©{currentYear} YOUGotaGift.com Ltd.</p>
      <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      <a href={TERMS_OF_USE_LINK} target="_blank" rel="noopener noreferrer">
        Terms of Use
      </a>
    </footer>
  );
};

export default MajorFooter;
